import * as THREE from 'three';

/**
 * 草图边解析最近点投影器抽象。
 *
 * 设计说明：
 * 1. 最近点捕捉策略只负责编排捕捉优先级，不应认识每一种草图曲线的参数定义；
 * 2. 各曲线族通过独立投影器提供解析几何投影，避免把渲染采样折线误当成设计几何；
 * 3. 新增曲线类型时只需扩展投影器并在组合根注册，不修改稳定的最近点求解流程。
 */
export abstract class AbstractSketchNearestPointProjector {
    /**
     * 判断投影器是否支持目标对象。
     *
     * @param targetObject 待投影草图对象。
     * @returns 支持目标对象时返回 true。
     */
    public abstract supports(targetObject: THREE.Object3D): boolean;

    /**
     * 将世界坐标投影到目标对象的解析几何上。
     *
     * @param targetObject 目标草图对象。
     * @param worldPosition 待投影世界坐标。
     * @returns 目标解析几何上的最近世界坐标；无法投影时返回 null。
     */
    public abstract project(
        targetObject: THREE.Object3D,
        worldPosition: THREE.Vector3,
    ): THREE.Vector3 | null;
}
